import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.css'],
})
export class AlertMessageComponent {
  @Input() type: 'success' | 'danger' = 'success';
  @Input() message: string = '';
}
